import { get } from '../tools/http';

export default {
    state: {
        fields: [
            {
                name: 'RMain',
                label: 'Главная',
                is_crutch: true,
                heading: 'Создаем будущее России,',
                slogan: 'открывая равные возможности для каждого',
            },
            {
                name: 'opportunities',
                label: 'Проекты',
                slogan: 'Брось вызов тысячам управленцев и попади в сообщество лидеров',
                link: '/portal/competitions',
            },
            {
                name: 'pumps',
                label: 'Обучение',
                slogan: 'Изучай то, что тебя действительно интересует',
                link: '/education',
            },
            {
                name: 'examples',
                label: 'Истории успеха',
                slogan: 'Познакомься с людьми, которыми мы гордимся',
                link: '/portal/success',
            },
            {
                name: 'gains',
                label: 'Помощь другим',
                slogan: 'Для тех, кто делает добрые дела и всегда готов помочь',
                link: '/portal/gains',
            },
        ],
    },
    mutations: {
        setMainTexts: (state, item) => {
            const fields = state.fields.slice();

            fields[1].label = item[`rotor_6_name`];
            fields[1].slogan = item[`rotor_6_text`];
            fields[2].label = item[`rotor_5_name`];
            fields[2].slogan = item[`rotor_5_text`];
            fields[3].label = item[`rotor_4_name`];
            fields[3].slogan = item[`rotor_4_text`];
            fields[4].label = item[`rotor_3_name`];
            fields[4].slogan = item[`rotor_3_text`];
            fields[5].label = item[`rotor_2_name`];
            fields[5].slogan = item[`rotor_2_text`];

            state.fields = fields;
        },
    },
    actions: {
        getMain: async ctx => {
            const pages = await get('cms', 'entity/select/page?name=main');
            ctx.commit('setMainTexts', pages.list[0].data);
        },
    },
    getters: {
        fields: (state, getters, rootState, rootGetters) => {
            return state.fields;
            // return rootGetters.user.id
            //     ? state.fields.filter(element => element.name != 'RMain')
            //     : state.fields;
        },
        name_index: (state, getters, rootState, rootGetters) => name => {
            const field = rootGetters.fields.find(f => f.name == name);

            return rootGetters.fields.indexOf(field);
        },
    },
};
